<template>
  <el-collapse-item
    :name="name"
    class="elemento-header"
  >
    <template #title>
      <span class="elemento-header__title">{{ title }}</span>
    </template>
    <slot />
  </el-collapse-item>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
.elemento-header__title {
  font-weight: 700;
  font-size: 1.1em;
  color: #303133;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
